export default __webpack_public_path__ + "static/media/bike2.3a5e57d2.png";